/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputSignalGroup
 */
export interface OutputSignalGroup {
    /**
     * 
     * @type {string}
     * @memberof OutputSignalGroup
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputSignalGroup
     */
    name?: string;
}

/**
 * Check if a given object implements the OutputSignalGroup interface.
 */
export function instanceOfOutputSignalGroup(value: object): boolean {
    return true;
}

export function OutputSignalGroupFromJSON(json: any): OutputSignalGroup {
    return OutputSignalGroupFromJSONTyped(json, false);
}

export function OutputSignalGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputSignalGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function OutputSignalGroupToJSON(value?: OutputSignalGroup | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

